<template>
  <div>
    <video-top-section />
    <categories-section />
    <products-section />
    <BannerProductSection />
    <about-section />
  </div>
</template>

<script>
import CategoriesSection from "../components/sections/CategoriesSection.vue";
import VideoTopSection from "../components/sections/VideoTopSection.vue";
import ProductsSection from "../components/sections/ProductsSection.vue";
import AboutSection from "../components/sections/AboutSection.vue";
import BannerProductSection from "../components/sections/BannerProductSection.vue";

export default {
  components: {
    VideoTopSection,
    CategoriesSection,
    ProductsSection,
    AboutSection,
    BannerProductSection,
  },
};
</script>
